<script setup>
import { onMounted, ref } from 'vue'
import { getOfflineTime, setOfflineTime } from '@/api/heating/devicePoint/devicePoint.js'
import { ElMessage } from 'element-plus'

const num = ref(1)
function getTime() {
    getOfflineTime({
        type: 2
    }).then((data) => {
        num.value = data?.offline_cycle ?? 4
    })
}
function handleChange() {
    setOfflineTime({
        type: 2,
        offline_cycle: num.value
    }).then((res) => {
        ElMessage.success('设置成功！')
    })
}

onMounted(() => {
    getTime()
})
</script>

<template>
    <div v-permission="['pipeline-sensor:params-config:offline-time']" class="data-container">
        <div class="title">“设备离线”基准判定时间</div>
        <el-form>
            <el-form-item label="离线判定时间（小时）">
                <el-input-number v-model="num" :min="1" :max="72" />
            </el-form-item>
            <el-form-item label="">
                <el-button type="primary" @click="handleChange">提交</el-button>
            </el-form-item>
        </el-form>
    </div>
</template>

<style scoped lang="scss">
.container {
    padding: 15px;
}
.title {
    font-size: 16px;
    line-height: 38px;
    font-weight: 600;
    margin-bottom: 20px;
    background-color: rgba(99, 164, 247, 0.1);
    border-left: 2px solid #63a4f7;
    text-indent: 10px;
}
</style>
